import createIcon from '../../createIcon';

/**
 * @component @name DoneOutline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNzcgNC45Mjk5OEwyMS4xNyA2LjMyOTk4TDguNDMgMTkuMDdMMi44MyAxMy40N0w0LjIzIDEyLjA3TDguNDMgMTYuMjdMMTkuNzcgNC45Mjk5OFpNMTkuNzcgMi4wOTk5OEw4LjQzIDEzLjQ0TDQuMjMgOS4yMzk5OEwwIDEzLjQ3TDguNDMgMjEuOUwyNCA2LjMyOTk4TDE5Ljc3IDIuMDk5OThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DoneOutline = createIcon('DoneOutline', [
  [
    'path',
    {
      d: 'M19.77 4.92998L21.17 6.32998L8.43 19.07L2.83 13.47L4.23 12.07L8.43 16.27L19.77 4.92998ZM19.77 2.09998L8.43 13.44L4.23 9.23998L0 13.47L8.43 21.9L24 6.32998L19.77 2.09998Z',
      key: 'ijsfcv',
    },
  ],
]);

export default DoneOutline;
